module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row text-xs-center"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.footer_logo),
      expression: "footer_logo"
    }],
    staticClass: "col-sm-3"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.footer_logo,
      "alt": _vm.appTitle
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.footerText),
      expression: "footerText"
    }],
    staticClass: "col-md-9 text-sm-right"
  }, [_c('p', {
    staticClass: "copy",
    domProps: {
      "innerHTML": _vm._s(_vm.footerText)
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf8dd274","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/Footer.vue
// module id = 450
// module chunks = 57